module.exports = __webpack_public_path__ + "static/VideoConference-e8223910c13c03da70e316820b090652.png";